module.exports = __webpack_public_path__ + "static/img/shisi.e44b8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shisi.png
// module id = H6+x
// module chunks = 1